import { type AppThunk } from "../../../index";
import { unsubscribeFromProductAutomation as actionCreator } from "../reducer";
import { closeRealtimeChannel } from "../../../helpers/closeRealtimeChannel";
import { claimRealtimeSlot } from "../../../helpers/realtimeSlot";

export const unsubscribeFromProductAutomation =
  (): AppThunk =>
  async (dispatch, getState, { subscriptions, db }) => {
    // take the slot so a subscribe still waiting on its fetch does not resurrect the channel
    claimRealtimeSlot(subscriptions, "productAutomation");

    // detach synchronously - awaiting the close first would let a subscribe that
    // already claimed the slot store its channel, only for this thunk to null it out
    const channel = subscriptions.realtimeProductAutomationChannel;
    subscriptions.realtimeProductAutomationChannel = null;
    subscriptions.productAutomationChannelName = null;
    void closeRealtimeChannel(db, channel);
    dispatch(actionCreator());
  };
